import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
import { useHeroStats } from './hooks/useHeroStats';

export default function HeroStats() {
  const { count, text } = useHeroStats();
  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.2 }}
      className="flex items-center space-x-2 pt-[3px]"
    >
      <Star className="w-5 h-5 text-[#f9c55f]" />
      <span className="text-sm font-medium text-gray-300">
        Trusted by {count}+ {text}
      </span>
    </motion.div>
  );
}